export const finePointer =
  typeof window !== "undefined" && !!window.matchMedia?.("(pointer: fine)").matches;
